export function formatNumber(n: number, decimals: number = 2): string {
  return parseFloat(n.toFixed(decimals)).toString();
}
